<template>
    <div
        class="flex-wrap offer-content order-md-3 d-flex"
        :class="territory === 'pol' ? 'justify-content-between' : 'align-items-start'"
    >
        <component :is="component" />

        <div v-if="!isUkDebtSolution" class="d-none order-lg-last order-last d-lg-flex mt-3 w-100">
            <TagContainer
                :offer="offer"
                :loanAmount="loanAmount"
                :loanTerm="loanTerm"
                :isOfferExpired="isOfferExpired"
                :fastFundingFlagStatus="fastFundingFlagStatus"
            />
        </div>
    </div>
</template>

<script>
import isDate from 'lodash/isDate'

export default {
    props: ['offer', 'loanAmount', 'loanTerm', 'fastFundingFlagStatus'],
    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
        component() {
            if (this.offer.type === 'credit card only') {
                return 'VariationCreditCardOnly'
            } else if (this.offer.type === 'line_of_credit' && this.includeTerritories('usa', 'gbr')) {
                // line_of_credit seems to be very different in USA
                return 'VariationLineOfCredit'
            } else if (this.offer.type === 'debt_solution' && this.includeTerritories('usa', 'gbr')) {
                return 'VariationDebtSolution'
            } else {
                // line_of_credit can still be in default variation when not in USA above
                return 'VariationDefault'
            }
        },
        isUkDebtSolution: function () {
            return this.offer.type === 'debt_solution' && this.includeTerritories('gbr')
        },
        isOfferExpired: function () {
            if (this.offer.offer_expires && isDate(new Date(this.offer.offer_expires))) {
                let date = new Date(this.offer.offer_expires) //YYYY-mm-DD
                let now = new Date()

                return now >= date
            }
        },
    },
}
</script>
